<div class="page-wrapper">
  <div class="row no-gutter">
    <div class="col-sm-12 content">
      @if (!deleted) {
        <h1>
          Please read this carefully You are about to submit a request for us to
          permanently close your account and delete your data. Once your account
          is closed all of the services accessed through your account will no
          longer be available to you, across any sites globally.
        </h1>
      }
      @if (deleted) {
        <h1>
          Your request has been submitted.<br />Your account will be deleted
          within 30 days.
        </h1>
      }
    </div>
    <form class="changePasswordForm" [formGroup]="changePasswordForm" (submit)="upadatePassword()" autocomplete="off">
      @if (!deleted) {
        <div class="form-elements">
          <div class="mobile">
            <label for="mobile" class="required">Mobile Number</label>
            <input class="form-control form-control-sm" type="text" formControlName="mobile"
              placeholder="{{ auth.userDetails.mobile }}" autocomplete="off" value="" maxlength="10" minlength="10"
              required readonly />
              <!-- <div class="error-section">
              <ng-container
              *ngIf="
                changePasswordForm.controls.mobile.errors &&
                (changePasswordForm.controls.mobile.touched ||
                  changePasswordForm.controls.mobile.dirty)
              "
                >
                <p
                  class="err-msg"
                [hidden]="
                  !changePasswordForm.get('mobile').hasError('required')
                "
                  >
                  Mobile Number is required
                </p>
                <p
                  class="err-msg"
                  [hidden]="!changePasswordForm.get('mobile').hasError('pattern')"
                  >
                  Invalid Mobile Number
                </p>
              </ng-container>
            </div> -->
          </div>
        </div>
      }
      @if (!deleted) {
        <div class="form-actions text-center">
          <button type="button" class="create-action" [ngClass]="changePasswordForm.valid ? 'hoverEffect' : ''"
            (click)="confirmDelete()">
            <span>Delete Account</span>
          </button>
        </div>
      }
    </form>

    @if (deleted) {
      <div class="text-center">
        <button [ngClass]="changePasswordForm.valid ? 'hoverEffect' : ''" type="button" class="confirm-action"
          (click)="navigate()">
          <span>Okay</span>
        </button>
      </div>
    }
  </div>
</div>